import {Model} from 'vue-mc';
import Config from "../config/config";

export default class manualReportModel extends Model {

	defaults() {
		return {
			data: {
				role_id: 0,
				role_privelege_set_id: 0,
				view_invoices: 0
			},
			description:"",
			role_id:""
		}
	}

	// Route configuration
	routes() {
		return {
			fetch: Config.localApiURL + 'clients/manual/download/'
		}
	}
}



// WEBPACK FOOTER //
// ./src/models/manualReportModel.js